"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosGWI = exports.postCancellableRequest = void 0;
var axios_1 = __importDefault(require("axios"));
var cookies_1 = require("./cookies");
var sso_1 = require("./sso");
var token_1 = require("./token");
var axiosInstancesMap = new Map();
var applicationName = '';
var env = '';
var dispatchError = function (error) {
    var event = new CustomEvent("".concat(applicationName, "ApplicationError"), { detail: error });
    if (window)
        window.dispatchEvent(event);
};
var requestHandler = function (request) {
    var token = (0, token_1.getToken)(env);
    request = __assign(__assign({}, request), { headers: __assign(__assign({}, request.headers), { Authorization: "Bearer ".concat(token) }) });
    if (request.method !== 'POST' && request.method !== 'post')
        return request;
    request.data = JSON.stringify(request.data);
    return request;
};
var errorInterceptor = function (response) {
    if (response.status && response.status < 400)
        return response;
    if (response.status && response.status === 422)
        return response;
    var errorMessage = 'We have a failure.';
    if (response.payload instanceof Error) {
        errorMessage = response.payload.message;
    }
    else if (response.payload instanceof String) {
        errorMessage = response.payload;
    }
    dispatchError(errorMessage);
    return response;
};
var errorHandler = function (error) {
    if (error.message === 'Request failed with status code 401') {
        (0, cookies_1.deleteAllCookies)();
        (0, sso_1.redirectToLogin)(env);
        return;
    }
    if (axios_1.default.isCancel(error) || error.message === 'Request failed with status code 422')
        return;
    var errorMessage = 'We have a failure.';
    if (error.message)
        errorMessage = error.message;
    dispatchError(errorMessage);
    return error;
};
var createAxiosInstance = function (environment, host, application, suppressGeneralError) {
    var axiosInstance = axios_1.default.create({
        baseURL: host,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    axiosInstance.interceptors.request.use(function (request) { return requestHandler(request); });
    if (suppressGeneralError !== true) {
        axiosInstance.interceptors.response.use(function (response) { return errorInterceptor(response); }, function (error) { return errorHandler(error); });
    }
    var instanceKey = "".concat(host, "_").concat(suppressGeneralError ? 'muted' : '');
    axiosInstancesMap = axiosInstancesMap.set(instanceKey, axiosInstance);
    applicationName = application;
    env = environment;
};
var getAxiosInstance = function (environment, host, appName, suppressGeneralError) {
    var instanceKey = "".concat(host, "_").concat(suppressGeneralError ? 'muted' : '');
    if (axiosInstancesMap === undefined)
        axiosInstancesMap = new Map();
    if (axiosInstancesMap.has(instanceKey))
        return axiosInstancesMap.get(instanceKey);
    else {
        createAxiosInstance(environment, host, appName, suppressGeneralError);
        return axiosInstancesMap.get(instanceKey);
    }
};
var cancelables;
var postCancellableRequest = function (axiosInstance, url, request, endpoint) {
    var cancelRequest = cancelables && cancelables.filter(function (x) { return x.Endpoint == endpoint; })[0];
    if (cancelRequest) {
        cancelRequest.Controller.abort();
        cancelables = cancelables.filter(function (x) { return x.Endpoint !== endpoint; });
    }
    cancelRequest = { Controller: new AbortController(), Endpoint: endpoint };
    if (cancelables)
        cancelables.push(cancelRequest);
    else
        cancelables = [cancelRequest];
    return axiosInstance.post(url, request, {
        signal: cancelRequest.Controller.signal
    });
};
exports.postCancellableRequest = postCancellableRequest;
exports.axiosGWI = axios_1.default;
exports.default = getAxiosInstance;
